__turbopack_context__.v({
  "chatHeader": "ClientChatHeader-module__LBRN6q__chatHeader",
});
